type EventListener<T extends Event = Event> = {
  targets: (null | HTMLElement | Node)[];
  events: string[];
  action?: "addEventListener" | "removeEventListener";
  handler: (event: T) => void;
};

const eventListener = <T extends Event>({
  targets,
  events,
  action = "addEventListener",
  handler,
}: EventListener<T>): any => {
  targets.forEach((target) => {
    events.forEach((eventName) => {
      if (target) {
        target[action](
          eventName,
          handler as EventListenerOrEventListenerObject
        );
      }
    });
  });

  return (): any =>
    eventListener({
      action: "removeEventListener",
      targets,
      events,
      handler,
    });
};

export default eventListener;
